module.exports = __webpack_public_path__ + "img/properties-placeholder.de444df3.jpg";